import { JobTitlePageMagazineArticle } from '@pflegia/data-access';

import RelevantArticles from '@shared/components/magazin/relevant-articles/RelevantArticles';
import { PostType } from '@shared/components/magazin/types';

import { SectionTitle } from '../../../job-detail/components/section/Section.component';

interface JobTitlePageMagazineSectionProps {
  articles: JobTitlePageMagazineArticle[];
}

const toPost = (article: JobTitlePageMagazineArticle): PostType =>
  ({
    id: article.id,
    slug: article.slug,
    title: article.title,
    featureImage: article.featureImage ?? '',
    featureImageAlt: article.featureImageAlt ?? '',
    excerpt: article.excerpt ?? '',
    publishedAt: article.publishedAt ?? '',
  }) as PostType;

export const JobTitlePageMagazineSection: React.FC<JobTitlePageMagazineSectionProps> = ({ articles }) => (
  <div className='my-8 w-full overflow-hidden' data-testid='job-title-page-magazine'>
    <SectionTitle
      className='!text-center text-2xl font-normal md:text-start lg:mb-16 lg:text-4xl'
      id='magazin'
      level='h2'
      titleKey='common:header.blog'
    />
    <div className='mt-8 w-full'>
      <RelevantArticles centered hideRelevantArticleTitle posts={articles.map(toPost)} showFourGrids />
    </div>
  </div>
);
